import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Badge, Button, Col, Container, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {DropDownList, GENERIC_DDL_TYPE} from "../listFilters/genericDDL";
import {COMPARISON_DDL_TYPE, ComparisonDropDownList} from "../listFilters/comparisonDDL";
import {Free_Text_TYPE, FreeText} from "./SideFilters/freeText";
import EQHErrorToast from "../EQHErrorToast";
import {READMIT_DDL_TYPE, ReadmitDropDownList} from "../listFilters/readmitDDL";
import {Wrapper} from './SideFilters/components'
import {SCHEDULE_DDL_TYPE, ScheduleApptDropDownList} from "../listFilters/scheduleApptDDL";
import {
    useCMWorklistContext
} from "../../views/caremgmt/worklist/components/CMWorklistModals/context/CMWorklist.context";
import {differenceInDays} from "date-fns";
import {isEmpty, isString, trim} from "lodash";
import {useLocation} from "react-router-dom";
import {getEcipEligibleHeader, SessionStorageUtil} from "../../utils/localStorageUtil";

const componentName = "filterGroup";

const areFilterParamsEqual = (first, second) =>
  JSON.stringify(first) === JSON.stringify(second);

const areFilterParamMapsEqual = (first, second) => {
  if (first === second) {
    return true;
  }

  if (!first || !second || first.size !== second.size) {
    return false;
  }

  for (const [key, value] of first.entries()) {
    if (!second.has(key) || JSON.stringify(second.get(key)) !== JSON.stringify(value)) {
      return false;
    }
  }

  return true;
};

const FilterGroupNew = ({
  filters,
  handleChange,
  filterParams,
  additionalValidation,
  setScheduleFilterApplied,
  extraFilters,
  isManageVisit = false,
  filterGroups = null,
  customWorklistName
}) => {
  const [errors, setErrors] = useState([]);
  const [insideErrors, setInsideErrors] = useState([]);
  const [reAdmitErrors, setreAdmitErrors] = useState([]);
  const workListContext = useCMWorklistContext();
  const [toggleAccordions, setToggleAccordions] = useState(null);
  const location = useLocation();
  const ecipEligibleHeader = getEcipEligibleHeader();
  //Key by Header map for the filters having different Key and Header value
  const constructKeyByHeader = useCallback(() => {
    const keyByHeaderMap = new Map();
    keyByHeaderMap.set("DOB", "Birth Date");
    keyByHeaderMap.set("DOB1", "Birth Date Comp");
    keyByHeaderMap.set("Validator", "Approve Reject Validator");
    keyByHeaderMap.set("Patient City", "City");
    keyByHeaderMap.set("Event Type1", "eventType");
    keyByHeaderMap.set("Patient Zip Code", "Zip Code");
    keyByHeaderMap.set("PCP Name", "PCP");
    keyByHeaderMap.set("PCP Name1", "PCP Filter");
    keyByHeaderMap.set("PCP Name2", "PCP Filter On Full Name");
    keyByHeaderMap.set("Roster Status", "Patients");
    keyByHeaderMap.set("Care Opportunity Name", "Opportunity Definition");
    keyByHeaderMap.set("Care Opportunity Status", "Opportunity Status");
    keyByHeaderMap.set("Care Opportunity Year", "Measure Year");
    keyByHeaderMap.set("Validation Status", "Validation");
    keyByHeaderMap.set("Event Type", "ADT Disposition");
    keyByHeaderMap.set("Facility", "ADT by Facility");
    keyByHeaderMap.set("MemberID", "memberIds");
    keyByHeaderMap.set("Source", "source");
    keyByHeaderMap.set("Source", "sourceNew");
    keyByHeaderMap.set("Line of Business", "lineOfBusiness");
    keyByHeaderMap.set("Admit Date", "latestAdmitDate");
    keyByHeaderMap.set("Admit Date", "latestAdmissionDate");
    keyByHeaderMap.set("Creation Date", "assignDate");
    keyByHeaderMap.set("Last PCP Visit", "lastPCPVisitFilter");
    keyByHeaderMap.set("Zone", "zone");
    keyByHeaderMap.set("Patient Engagement", "engagement");
    keyByHeaderMap.set("Visit Gap Type", "gapVisitType");
    keyByHeaderMap.set("Status", "worklistStatus");
    keyByHeaderMap.set("Visit Gap Status", "singleWorkListStatus");
    keyByHeaderMap.set("Missed Opportunity", "missedOppStatus");
    keyByHeaderMap.set("Appointment Date", "ScheduleAppt");
    keyByHeaderMap.set("Care Step Name", "Care Step Type");
    keyByHeaderMap.set(ecipEligibleHeader, "ecipEligible");
    keyByHeaderMap.set("Market", "fileinput");
    keyByHeaderMap.set("Care Program Status", "Care Path Status");
    keyByHeaderMap.set("Care Program Step Due Date", "Due Date");
    keyByHeaderMap.set("Current Hospital", "Hospital");
    return keyByHeaderMap;
  }, [ecipEligibleHeader]);

  const handleOffCanvas = useCallback(() => {
    setQueuedDataMap(new Map());
  }, []);

  const [openAccordions, setOpenAccordions] = useState({});

  const toggleAccordion = useCallback((key) => {
    setOpenAccordions(prevState => ({
      ...prevState,
      [key]: !prevState[key]
    }));
  }, []);

  useEffect(() => {
    const offcanvasElement = document.getElementById('offcanvasFilters');
    offcanvasElement && offcanvasElement.addEventListener('hidden.bs.offcanvas', handleOffCanvas)
    return () => {
      offcanvasElement && offcanvasElement.removeEventListener('hidden.bs.offcanvas', handleOffCanvas);
    };
  }, [handleOffCanvas]);

  const keyByHeader = useMemo(() => constructKeyByHeader(), [constructKeyByHeader]);

  const getFilterParamsFromSelected = useCallback((hidden) => {
    const map = new Map();
    for (const fp of filterParams) {
      const def = filters.find(item =>
        (item.getKey?.() === fp.paramName) ||
        (item.key === fp.paramName) ||
        (item.getHeader?.() === fp.paramName)
      );
      const isInThisPanel = !!def;
      if ((hidden && !isInThisPanel) || (!hidden && isInThisPanel)) {
        const header = def?.getHeader?.() ?? def?.header ?? fp.paramName;
        map.set(header, fp);
      }
    }
    return map;
  }, [filterParams, filters]);

  const [lastFilterParamChanged, setLastFilterParamChanged] = useState();
  const [show, setShow] = useState(false);
  const [groupedFilters, setGroupedFilters] = useState([]);

  const [dataMap, setDataMap] = useState(() =>
    getFilterParamsFromSelected(false)
  );
  const [queuedDataMap, setQueuedDataMap] = useState(new Map());

  useEffect(() => {
    const el = document.getElementById('offcanvasFilters');
    const onShow = () => {
      setDataMap(getFilterParamsFromSelected(false));
      setQueuedDataMap(new Map());
      setErrors([]);
      setreAdmitErrors([]);
      setInsideErrors([]);
    };
    el && el.addEventListener('show.bs.offcanvas', onShow);
    return () => el && el.removeEventListener('show.bs.offcanvas', onShow);
  }, [filterParams, filters, getFilterParamsFromSelected]);

  useEffect(() => {
    const selectedDataMap = getFilterParamsFromSelected(false);

    setDataMap(prevDataMap =>
      areFilterParamMapsEqual(prevDataMap, selectedDataMap) ? prevDataMap : selectedDataMap
    );
  }, [getFilterParamsFromSelected]);

  const handleClose = () => {
    setQueuedDataMap(new Map());
    let closeCanvas = document.getElementById('closeSideFilters');
    closeCanvas && closeCanvas.click();
    setErrors([]);
    setShow(false);
    setreAdmitErrors([]);
    setInsideErrors([]);
    if (location.pathname.includes('my_members')) {
      SessionStorageUtil.setObj('backing', false)
    }
  };

  const hasDisplayValue = (filterParam) => {
    if (isEmpty(filterParam.displayValue)) {
      return false;
    }

    const nonEmptyValues = filterParam.displayValue?.filter(value => {
      if (isString(value)) {
        return !isEmpty(trim(value))
      }
      return true;
    });

    return !isEmpty(nonEmptyValues);
  }

  const removeFilterParam = (param) => {
    dataMap.delete(param);
    filterParams = [];
    dataMap.forEach((filterParam, key, map) => {
      if (hasDisplayValue(filterParam)) {
        filterParams.push(filterParam);
      }
    });
    if (setScheduleFilterApplied && !filterParams.length) {
      setScheduleFilterApplied(false);
    }
    handleChange(filterParams);
  };

  const clearAllFilters = useCallback(() => {
    workListContext && workListContext.sendEvent('CLEAR_ALL_FILTER');
    setDataMap(new Map());
    setQueuedDataMap(new Map());
  }, [workListContext]);

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("my_members")) {
      clearAllFilters()
      setInsideErrors([])
    }
  }, [clearAllFilters])

  const getMergedMaps = () => {
    const mergedMap = new Map(dataMap);
    queuedDataMap.forEach((filterParam, key, map) => {
      if (filterParam.paramValue && filterParam.paramValue.length) {
        mergedMap.set(filterParam.paramName, filterParam);
      } else {
        mergedMap.delete(filterParam.paramName);
      }
    });
    return mergedMap;
  };

  const handleFilterChange = useCallback((filterParam) => {
    if (filterParam.paramName) {
      const nextFilterParam = checkComparisonFilters(filterParam)
        ? { ...filterParam, paramValue: null }
        : filterParam;

      setQueuedDataMap((prevMap) => {
        if (areFilterParamsEqual(prevMap.get(filterParam.paramName), nextFilterParam)) {
          return prevMap;
        }

        const newMap = new Map(prevMap);
        newMap.set(filterParam.paramName, nextFilterParam);
        return newMap;
      });
      setLastFilterParamChanged((prevFilterParam) =>
        areFilterParamsEqual(prevFilterParam, filterParam) ? prevFilterParam : filterParam
      );
    }
  }, []);

  const checkComparisonFilters = (filterParam) => {
    let res = false
    if (
      filterParam.paramName === 'DOB1' ||
      filterParam.paramName === 'Birth Date Comp' ||
      filterParam.paramName === 'Next upcoming Visit Date'
    ) {
      res = (!filterParam?.paramValue?.[0] && !filterParam?.paramValue?.[1]) || filterParam?.paramValue.every((x) => x === "")
    }
    return res
  }

  const validate = () => {
    const newerrors = [];
    const mergedMap = getMergedMaps();
    let hasReadmitError = false;
    let hasInsideError = null;

    mergedMap.forEach((filterParam) => {
      if (filterParam?.paramName === 'Readmit' && filterParam?.comparison === 'range') {
        hasReadmitError = validateReadmit(filterParam);
      } else if (
          filterParam.paramName === 'DOB1' ||
          filterParam.paramName === 'Birth Date Comp' ||
          filterParam.paramName === 'Next upcoming Visit Date'
        ) {
        hasInsideError = validateFilters(filterParam).length > 0;
        hasInsideError && setInsideErrors([...validateFilters(filterParam)])
      } else {
        newerrors.push(validateFilters(filterParam));
      }
    });

    if (!hasReadmitError) {
      const validateBadInput = (id) => {
        return document.querySelector('#' + id)?.validity?.badInput
      }
      let errors = []
      if (validateBadInput('ReadmitDDL-READMIT-datePicker')) {
        errors.push('Readmit Needs A Valid Date For Start Date');
      }
      if (validateBadInput('ReadmitDDL-READMIT-datePicker2')) {
        errors.push('Readmit Needs A Valid Date For End Date');
      }
      if (errors.length) {
        setreAdmitErrors(errors)
        hasReadmitError = true;
      }
    }
    additionalValidation && additionalValidation(mergedMap, newerrors);
    return hasReadmitError ? 'readmitError' : hasInsideError ? 'insideError' : newerrors.filter(n => n.length > 0);
  };

  const validateFilters = (filterParam) => {
    const newerrors = [];
    if (filterParam.paramValue && filterParam.paramValue.length) {
      if (filterParam.comparison === "range") {
        const startDateTime = Date.parse(filterParam.paramValue[0]);
        const endDateTime = Date.parse(filterParam.paramValue[1]);
        const filterName = getHeaderOrDefault(filterParam.paramName);

        if (startDateTime > endDateTime) {
          newerrors.push(`${filterName} Start date must be less than or equal to End date.`)
        }
        if (isNaN(startDateTime) || startDateTime === '') {
          newerrors.push(
            `${filterName} Needs A Valid Date For Start Date`
          );
        }
        if (isNaN(endDateTime) || endDateTime === '') {
          newerrors.push(
            `${filterName} Needs A Valid Date For End Date`
          );
        }
      }
    }
    return newerrors
  }

  const getHeaderOrDefault = (filterName) => {
    if (filterName === 'DOB1') {
      return 'DOB'
    }
    if (filterName === 'Care Program Due Date') {
      return 'Due Date'
    }
    return filterName
  }

  const validateReadmit = (filterParam) => {
    let newerrors = []
    const readmitStart = filterParam?.paramValue.filter(p => p.includes('startDate'));
    const readmitEnd = filterParam?.paramValue.filter(p => p.includes('endDate'));
    if (readmitStart.length > 0 || readmitEnd.length > 0) {
      const validation = validateFilters({
        ...filterParam, paramValue: [
          readmitStart.length > 0 ? readmitStart[0] : '',
          readmitEnd.length > 0 ? readmitEnd[0] : ''
        ]
      });
      if (validation.length > 0) {
        newerrors = [...validation];
      }
    }
    setreAdmitErrors(newerrors)
    return newerrors.length > 0
  }

  const applyFilters = () => {
    const validation = validate()

    if (setScheduleFilterApplied) {
      setScheduleFilterApplied(true);
    }

    if (validation?.length > 0 && validation !== 'readmitError' && validation !== 'insideError') {
      setErrors(validation);
    } else if (validation !== 'readmitError' && validation !== 'insideError') {
      const filterParams = [
        ...Array.from(getFilterParamsFromSelected(true).values()),
      ];
      const mergedMaps = getMergedMaps();
      mergedMaps.forEach((filterParam, key, map) => {
        if (keyByHeader.has(filterParam.paramName)) {
          filterParam.paramName = keyByHeader.get(filterParam.paramName);
        }
        if (hasDisplayValue(filterParam)) {
          filterParams.push(filterParam);
        }
        if (!hasDisplayValue(filterParam) && filterParam.paramName === 'Next upcoming Visit Date' && filterParam?.paramValue?.length > 0) {
          filterParams.push(filterParam);
        }
      });
      setDataMap(mergedMaps);
      workListContext && dispatchEvents(mergedMaps);

      if (!SessionStorageUtil.getObj('backing')) {
        handleChange(filterParams);
      }
      handleClose();
    }
  };

  useEffect(() => {
    if (!location.pathname.includes('my_members') && SessionStorageUtil.getObj('backing')) {
      setTimeout(() => {
        const applyButton = document.getElementById('apply-button');
        applyButton && applyButton.click();
        SessionStorageUtil.setObj('backing', false)
      }, 100);
    }
  }, [location])

  const dispatchEvents = (mergedMaps) => {
    const newArray = Array.from(mergedMaps).map(e => e[0]);
    newArray.forEach(e => {
      eventMap?.[e] && workListContext.sendEvent(eventMap[e]);
    });
  }

  const eventMap = {
    'Event Type': 'APPLY_EVENT_TYPE_FILTER',
    'Payor': 'APPLY_PAYOR_FILTER',
    'Care Step Type': 'APPLY_CARE_STEP_FILTER',
    'Assigned To': 'APPLY_ASSIGN_TO_FILTER',
    'Patient Risk Level': 'APPLY_RISK_LEVEL_FILTER',
    'Existing Program': 'APPLY_EXISTING_PROGRAM_FILTER',
    'Due Date': 'APPLY_DUE_DATE_FILTER',
    'Readmit': 'APPLY_READMIT_FILTER',
    'Patient Status': 'APPLY_PATIENT_STATUS_FILTER',
    'Provider': 'APPLY_PROVIDER_FILTER',
    'Source': 'APPLY_SOURCE_FILTER',
    'Patient Engagement': 'APPLY_ENGAGE_PCP_FILTER',
    'Zone': 'APPLY_ZONE_FILTER',
    'Care Path Status': 'APPLY_CARE_PATH_STATUS_FILTER',
    'Hospital': 'APPLY_HOSPITAL_FILTER'
  }

  const getConvertedTex = (displayValue) => {
    var displayValueConverted = '';

    switch (displayValue) {
      case 'ER_ADMIT':
        displayValueConverted = 'ER Readmit';
        break;
      case 'IP_ADMIT':
        displayValueConverted = 'IP Readmit';
        break;
      case 'BH_IP_ADMIT':
        displayValueConverted = 'BH-IP Readmit';
        break;
      default:
        break;
    }
    return displayValueConverted;
  }

  const ReAdmitBadge = ({ tooltip, span, paramName }) => {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
        <Badge id={`${componentName}-activeFilter`} className="btn-filter border cursor-p">
          <span className="me-2 text-truncate">{span}</span>
          <i className="fa-sharp fa-solid fa-xmark" onClick={() => removeFilterParam(paramName)}></i>
        </Badge>
      </OverlayTrigger>
    )
  }

  const getBadgeLabel = (filterParam) => {
    if ((filterParam?.paramName === 'Due Date' || filterParam?.paramName === 'Date') && filterParam.paramValue.length >= 2) {
      const date0 = filterParam.paramValue[0]
      const date1 = filterParam.paramValue[1]
      const diff = differenceInDays(new Date(date1), new Date(date0))
      switch (diff) {
        case 30:
          return 'Last 30 Days'
        case 60:
          return 'Last 60 Days'
        case 90:
          return 'Last 90 Days'
        default:
          break;
      }
      return date0 + ' - ' + date1;
    }
    return 'Multiple'
  }

  const getReadmitButton = (filterParam, key) => {
    if (filterParam?.paramValue?.[0].includes('startDate')) {
      const dateValue = filterParam.paramValue[0].replace('startDate:', '') + ' - ' + filterParam.paramValue[1].replace('endDate:', '');
      if (filterParam.paramValue.length === 2) {
        return (
          <ReAdmitBadge
            key={key}
            tooltip={`${filterParam.paramName}: ${dateValue}`}
            span={`${filterParam.paramName}: ${dateValue}`}
            paramName={filterParam?.paramName}
          />
        )
      } else if (filterParam.paramValue.length === 3) {
        return (
          <ReAdmitBadge
            key={key}
            tooltip={`${filterParam.paramName}: ${dateValue}`}
            span={`${filterParam.paramName}: ${getConvertedTex(filterParam.paramValue[2])} ${dateValue}`}
            paramName={filterParam?.paramName}
          />
        )
      } else if (filterParam.paramValue.length > 3) {
        return (
          <ReAdmitBadge
            key={key}
            tooltip={`${filterParam.paramName}: ${dateValue}`}
            span={`${filterParam.paramName}: Multiple ${dateValue}`}
            paramName={filterParam?.paramName}
          />
        )
      }
    } else if (filterParam?.paramValue?.length === 1) {
      const displayValueConverted = getConvertedTex(filterParam.displayValue[0]);
      return (
        <ReAdmitBadge
          key={key}
          tooltip={`${filterParam.paramName}: ${displayValueConverted}`}
          span={`${filterParam.paramName}: ${displayValueConverted}`}
          paramName={filterParam?.paramName}
        />
      );
    } else {
      return (
        <ReAdmitBadge
          key={key}
          tooltip={`${filterParam.paramName}`}
          span={`${filterParam.paramName}: Multiple`}
          paramName={filterParam?.paramName}
        />
      );
    };
  }
  const getFilterButtons = filterParams => {
    let filterButtons = [];
    let dateValue;
    let buttonIndex = 0;
    for (let filterParam of filterParams) {
      const badgeKeyBase = `${filterParam.paramName ?? "filter"}-${buttonIndex}`;
      buttonIndex += 1;
      let filterName = filterParam.paramName;
      const keyByHeaderValues = [...keyByHeader.values()];
      if (keyByHeaderValues.includes(filterName)) {
        const keyValues = keyByHeader.keys();
        for (let keyValue of keyValues) {
          filterName = (filterName === keyByHeader.get(keyValue)) ? keyValue : filterName;
        }
      }
      const selectedFilterParams = [
        ...Array.from(getFilterParamsFromSelected(true).keys()),
      ];
      if (filterParam.paramValue.length > 0
        && !selectedFilterParams.includes(filterName)
      ) {
        if ((filterParam.comparison !== 'month'
          && (filterParam.paramName === 'DOB'
            || filterParam.paramName === 'Birth Date'
            || filterParam.paramName === 'Birth Date Comp'
            || filterParam.paramName === 'Care Program Step Due Date'
            || filterParam.paramName === 'Next upcoming Visit Date'
          )) || (filterParam.paramName === 'ADT Event Date')
          || (filterParam.paramName === 'Latest Discharge Date')
          || (filterParam.paramName === 'Expired Date')
          || (filterParam.paramName === 'Last Known Visit')
          || (filterParam.paramName === 'Risk Score')
          || (filterParam.paramName === 'Validation Date')
          || (filterParam.paramName === 'Date of Service')
          || (filterParam.paramName === 'Status Update Date')
        ) {
          switch (filterParam.comparison) {
            case 'month':
              dateValue = 'Month - ' + filterParam.displayValue;
              break;
            case 'eq':
              dateValue = 'On - ' + filterParam.paramValue[0];
              if (filterParam.paramName === 'Risk Score') {
                dateValue = 'Equal to ' + filterParam.paramValue[0];
              }
              break;
            case 'lt':
              dateValue = 'Prior - ' + filterParam.paramValue[0];
              if (filterParam.paramName === 'Risk Score') {
                dateValue = 'Less than ' + filterParam.paramValue[0];
              }
              break;
            case 'gt':
              dateValue = 'Since - ' + filterParam.paramValue[0];
              if (filterParam.paramName === 'Risk Score') {
                dateValue = 'Greater than ' + filterParam.paramValue[0];
              }
              break;
            case 'gte':
              dateValue = 'Since - ' + filterParam.paramValue[0];
              break;
            case 'range':
              dateValue = 'Range ' + filterParam.paramValue[0] + ' - ' + filterParam.paramValue[1];
              break;
            default:
              dateValue = filterParam.paramValue;
          }
          filterButtons.push(
            <OverlayTrigger key={badgeKeyBase} placement="top" overlay={<Tooltip>{filterName?.replace(/\d+/g, '')}: {dateValue}</Tooltip>}>
              <Badge id={`${componentName}-activeFilter`} className="btn-filter border cursor-p">
                <span className="me-2 text-truncate">{filterName?.replace(/\d+/g, '')}: {dateValue}</span>
                <i className="fa-sharp fa-solid fa-xmark" onClick={() => { removeFilterParam(filterName); }}></i>
              </Badge>
            </OverlayTrigger>
          );
        } else if (filterParam.paramName === 'Readmit' && filterParam.comparison === 'range') {
          filterButtons.push(getReadmitButton(filterParam, badgeKeyBase));
        } else {
          if (filterParam.paramValue.length > 1) {
            const label = getBadgeLabel(filterParam);
            filterButtons.push(
              <OverlayTrigger key={badgeKeyBase} placement="top" overlay={<Tooltip>{filterName?.replace(/\d+/g, '')}: {label}</Tooltip>}>
                <Badge id={`${componentName}-activeFilter`} className="btn-filter border cursor-p">
                  <span className="me-2 text-truncate">{filterName?.replace(/\d+/g, '')}: {label}</span>
                  <i className="fa-sharp fa-solid fa-xmark" onClick={() => { removeFilterParam(filterName); }}></i>
                </Badge>
              </OverlayTrigger>
            );
          }
          else {
            filterButtons.push(
              <OverlayTrigger key={badgeKeyBase} placement="top" overlay={<Tooltip>{filterName === 'W30 Approved' || filterName === 'W15 Approved' ? filterName : filterName?.replace(/\d+/g, '')}: {filterParam.displayValue}</Tooltip>}>
                <Badge id={`${componentName}-activeFilter`} className="btn-filter border cursor-p">
                  <span className="me-2 text-truncate">{filterName === 'W30 Approved' || filterName === 'W15 Approved' ? filterName : filterName?.replace(/\d+/g, '')}: {filterParam.displayValue}</span>
                  <i className="fa-sharp fa-solid fa-xmark" onClick={() => { removeFilterParam(filterName); }}></i>
                </Badge>
              </OverlayTrigger>
            );
          }
        }
      }
    }
    return filterButtons;
  };

  const groupElements = useCallback(() => {
    const groupObject = filterGroups;
    const elements = filters;
    const keys = Object.keys(groupObject);
    const groupedResult = keys.reduce((acc, group) => {
      acc[group] = [];
      return acc;
    }, {});
    groupedResult['singles'] = [];

    elements.forEach(element => {
      const header = element.getHeader(element);
      let matched = false;
      for (const [group, items] of Object.entries(groupObject)) {
        if (items.includes(header)) {
          groupedResult[group].push(element);
          matched = true;
          break;
        }
      }
      if (!matched) {
        groupedResult['singles'].push(element);
      }
    });

    for (const group in groupedResult) {
      if (groupedResult[group].length === 0) {
        delete groupedResult[group];
      }
    }
    setGroupedFilters({ ...groupedResult })
  }, [filterGroups, filters]);

  useEffect(() => {
    if (Object.keys(filterGroups || {}).length > 0 && !openAccordions) {
      const initialOpenState = Object.keys(filterGroups).reduce((acc, key) => ({
        ...acc,
        [key]: false
      }), {});
      setOpenAccordions(initialOpenState);
      groupElements();
    }
  }, [filterGroups, groupElements, openAccordions]);

  useEffect(() => {
    if (Object.keys(filterGroups || {}).length > 0 && !toggleAccordions) {
      const keys = Object.keys(filterGroups).map(f => [f, false]);
      const obj = keys.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
      setToggleAccordions({ ...obj })
      groupElements()
    }
  }, [filterGroups, groupElements, toggleAccordions])

  const renderFilterComponent = useCallback((filter, idx, dataMapClone) => {
    return (
      <Col key={`${componentName}-filter-${idx}-${filter.getHeader()}`}>
        <FilterNew
          filterDefinition={filter}
          handleChange={handleFilterChange}
          selected={
            queuedDataMap.get(filter.getHeader()) ??
            dataMap.get(filter.getHeader())
          }
          externalDataMap={dataMapClone}
          onLoad={(externalDataMap, selectedData, setData) =>
            filter.onLoad
              ? filter.onLoad(
                externalDataMap,
                selectedData,
                setData,
                lastFilterParamChanged
              )
              : null
          }
          idx={idx}
          errors={reAdmitErrors.length > 0 ? reAdmitErrors : errors}
          insideErrors={insideErrors}
        />
      </Col>
    );
  }, [handleFilterChange, queuedDataMap, dataMap, reAdmitErrors, errors, insideErrors, lastFilterParamChanged]);

  return (
    <>
      <Wrapper
        badges={getFilterButtons(filterParams)}
        extraFilters={extraFilters}
        isManageVisit={isManageVisit}
        setShow={setShow}
        show={show}
      >
        <EQHErrorToast
          id={'filterErrors'}
          errors={errors}
          handleClose={() => {
            setErrors([]);
            setreAdmitErrors([]);
            setInsideErrors([])
          }}
          isList
        />
        <Container>
          <Row xs={1} sm={1} md={1}>
            {(Object.keys(filterGroups || {}).length > 0 && customWorklistName === 'ALL PATIENTS')
              ? <>{Object.keys(groupedFilters)
                .filter(k => k !== 'singles')
                .map((k, idx) => (
                  <Row xl={1} key={k}>
                    <Col className="border-bottom p-0">
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id={`heading-${k}`}
                          onClick={() => toggleAccordion(k)}
                        >
                          <button
                            className="accordion-button fw-bold"
                            type="button"
                            aria-expanded={openAccordions[k]}
                            aria-controls={`collapse-${k}`}
                            id={`accordion-${k}`}
                          >
                            <i className={`fa fa-chevron-${openAccordions[k] ? 'down' : 'right'}`} aria-hidden='true'></i>
                            {k}
                          </button>
                        </h2>
                        <div
                          id={`collapse-${k}`}
                          className={`accordion-collapse collapse ${openAccordions[k] ? 'show' : ''}`}
                          aria-labelledby={`heading-${k}`}
                        >
                          <div className="accordion-body">
                            {groupedFilters?.[k].map((filter, idx) => {
                              const dataMapClone = getMergedMaps();
                              return renderFilterComponent(filter, idx, dataMapClone)
                            })}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ))}
                {groupedFilters?.singles &&
                  groupedFilters.singles.map((filter, idx) => {
                    const dataMapClone = getMergedMaps();
                    return renderFilterComponent(filter, idx, dataMapClone)
                  })
                }
              </>
              : filters?.map((filter, idx) => {
                const dataMapClone = getMergedMaps();
                return renderFilterComponent(filter, idx, dataMapClone)
              })
            }
          </Row>
        </Container>
        <div className="accordion-footer position-absolute bottom-0 d-flex justify-content-between p-4 bg-white w-100">
          <Button onClick={() => clearAllFilters()}>Clear All</Button>
          <Button id={"apply-button"} onClick={() => applyFilters()}>Apply</Button>
        </div>
      </Wrapper >
    </>
  );
};

const FilterNew = ({ filterDefinition, ...other }) => {
  filterDefinition.componentProps = {
    ...filterDefinition.componentProps,
    ...other,
  };

  return (
    {
      [GENERIC_DDL_TYPE]: (
        <DropDownList
          {...filterDefinition.componentProps}
          header={filterDefinition.getHeader()}
        />
      ),
      [COMPARISON_DDL_TYPE]: (
        <ComparisonDropDownList
          {...filterDefinition.componentProps}
          header={filterDefinition.getHeader()}
        />
      ),
      [READMIT_DDL_TYPE]: (
        <ReadmitDropDownList
          {...filterDefinition.componentProps}
          header={filterDefinition.getHeader()}
        />
      ),
      [SCHEDULE_DDL_TYPE]: (
        <ScheduleApptDropDownList
          {...filterDefinition.componentProps}
          header={filterDefinition.getHeader()}
        />
      ),
      [Free_Text_TYPE]: (
        <FreeText
          {...filterDefinition.componentProps}
          header={filterDefinition.getHeader()}
        />
      ),
    }[filterDefinition.type] || <div></div>
  );
};

export { FilterGroupNew, FilterNew };
